module.exports = __webpack_public_path__ + "img/template_1.c0fab2e2.png";